import { AddCustomerQuotePage, AddPartBomPage } from 'iframe/pages';

import { iframeAddCustomerQuotePath, iframeAddPartBomPath } from './routePaths';

const iframeAddCustomerQuote = {
  path: iframeAddCustomerQuotePath(),
  exact: true,
  isPrivate: true,
  element: <AddCustomerQuotePage />,
};

const iframeAddPartBom = {
  path: iframeAddPartBomPath(),
  exact: true,
  isPrivate: true,
  element: <AddPartBomPage />,
};

export const iframeRoutes = [iframeAddCustomerQuote, iframeAddPartBom];
